import { render, staticRenderFns } from "./BookIaps.vue?vue&type=template&id=ee431ca6&"
import script from "./BookIaps.vue?vue&type=script&lang=js&"
export * from "./BookIaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports